import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type BacktestTurnoverProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;
  title: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;

  fullScreen?: boolean;
  context?: ts.types.signal.SignalAnalysisContext;
  widgetPaths?: Record<'signal_turnover', string>;
};

const BacktestTurnover = ({
  id,
  readOnly,
  widgetKey,
  params,
  setParams,
  mode,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: BacktestTurnoverProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        readOnly={readOnly}
        widgetKey={widgetKey}
        fullScreen={fullScreen}
        loadWidgetData={loadWidgetData}
        params={params as Params}
        turnover={widgetPaths['signal_turnover']}
        title={title}
      />
    </>
  );

  return <>{mode == 'edit' ? <Form params={params} setParams={setParams} /> : renderJobComponent()}</>;
};

export default BacktestTurnover;
